import {
    addDays,
    eachDayOfInterval,
    endOfMonth,
    isMonday,
    isSunday,
    startOfMonth,
} from "date-fns";

export const MONTH_NAMES = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

export const MONTH_SHORT_NAMES = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

export const WEEKDAY_NAMES = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
];

export const WEEKDAY_SHORT_NAMES = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun",
];

export const leadZero = (value: number | undefined | null) =>
    String(value ?? 0).padStart(2, "0");

export const dateToApi = (date: Date | string | number | undefined | null) => {
    if (!date) {
        return 0;
    }

    const d = new Date(date);

    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const day = d.getDate();

    return day + month * 100 + year * 10000;
};

export function dateFromApi(date: number): Date;
export function dateFromApi(date: null | undefined): null;
export function dateFromApi(date: number | null | undefined): Date | null;

export function dateFromApi(date: number | undefined | null) {
    if (!date) {
        return null;
    }

    const day = date % 100;
    const month = Math.floor(date / 100) % 100;
    const year = Math.floor(date / 10000);

    return new Date(year, month - 1, day);
}

export const stringDateFromApi = (date: number | undefined | null) => {
    const d = dateFromApi(date);

    if (!d) {
        return "";
    }

    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const hour = d.getHours();
    const minute = d.getMinutes();
    const second = d.getSeconds();

    return `${year}-${leadZero(month)}-${leadZero(day)}T${leadZero(
        hour,
    )}:${leadZero(minute)}:${leadZero(second)}`;
};

export function equalsApiDate(dateApi: number, date: Date): boolean;
export function equalsApiDate(
    dateApi: number,
    year: number,
    month?: number,
    day?: number,
): boolean;

export function equalsApiDate(
    dateApi: number,
    dateOrYear: Date | number,
    month?: number,
    day?: number,
) {
    const ad = dateApi % 100;
    const am = Math.floor(dateApi / 100) % 100;
    const ay = Math.floor(dateApi / 10000);

    const isDate = dateOrYear instanceof Date;
    const bd = isDate ? dateOrYear.getDate() : day;
    const bm = isDate ? dateOrYear.getMonth() + 1 : month;
    const by = isDate ? dateOrYear.getFullYear() : dateOrYear;

    return (
        ay === by &&
        (bm === undefined || am === bm) &&
        (bd === undefined || ad === bd)
    );
}

export const compareApiDates = (dateA: number, dateB: number) => {
    const ad = dateA % 100;
    const am = Math.floor(dateA / 100) % 100;
    const ay = Math.floor(dateA / 10000);

    const bd = dateB % 100;
    const bm = Math.floor(dateB / 100) % 100;
    const by = Math.floor(dateB / 10000);

    if (ay !== by) {
        return ay - by;
    }

    if (am !== bm) {
        return am - bm;
    }

    return ad - bd;
};

export const getTimezoneOffset = (timeZone: string) => {
    const d = new Date();

    d.setMilliseconds(0);

    return Date.parse(d.toLocaleString("en-US", { timeZone })) - d.getTime();
};

export const dateFromTimezone = (dateTime: string, timeZone: string) => {
    const date = new Date(dateTime);

    return new Date(date.getTime() - getTimezoneOffset(timeZone));
};

// week starts at Monday, ends at Sunday
//
export const getMonthGrid = (date: Date) => {
    const start = startOfMonth(date);
    const end = endOfMonth(date);
    const days = eachDayOfInterval({
        start,
        end,
    });

    while (!isMonday(days[0])) {
        days.unshift(addDays(days[0], -1));
    }

    while (!isSunday(days[days.length - 1])) {
        days.push(addDays(days[days.length - 1], 1));
    }

    return days;
};
